var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kws-quiz-meter-bar"},[_c('div',{staticClass:"meter-bar-outer"},[_c('span',{staticClass:"meter-bar-inner",style:(`width: ${_vm.value}%`)})]),_c('div',{staticClass:"meter-bar-text"},[_vm._v(_vm._s(`${_vm.value} %`))])])
}
var staticRenderFns = []

export { render, staticRenderFns }